if (!customElements.get('variant-selects')) {
  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }

      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }

      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });

        this.rescueOrphanedSelection();
      }

      /**
       * Hide-unavailable support (port of the overhaul's selection cascade).
       *
       * product-variant-options.liquid skips values no available variant can
       * reach, and this element is re-rendered on every selection - so a
       * selection that no longer survives the narrowing simply is not rendered,
       * leaving its group with nothing checked. Move to the first value that
       * did survive and dispatch a change so the theme's own update flow
       * reconciles price, media and the add-to-cart button. Runs once per
       * render; a move that orphans a later group is caught on that render,
       * so the cascade settles left to right like the overhaul's render loop.
       */
      rescueOrphanedSelection() {
        requestAnimationFrame(() => {
          const groups = this.querySelectorAll('fieldset');
          for (const group of groups) {
            const radios = Array.from(group.querySelectorAll('input[type="radio"]'));
            if (!radios.length || radios.some((radio) => radio.checked)) continue;
            const first = radios.find((radio) => !radio.disabled) || radios[0];
            first.checked = true;
            first.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
          for (const select of this.querySelectorAll('select')) {
            if (!select.options.length || select.querySelector('option[selected]')) continue;
            select.options[0].setAttribute('selected', 'selected');
            select.value = select.options[0].value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;

        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');

          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }

          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
